module.exports = __webpack_public_path__ + "static/media/visa.113429bb.svg";